window.fwk.controllers.searchPredictAndSuggest = function(config) {
    this.initText = '';
    var mthis = this;

    this.urlPredict = '';
    this.urlPredict = config.url_dominio_microfwk+'services/search/predictive?region=' + window.utils.userType.checkRegion();
    this.urlSearchGenre = '/search?type=genre&q={@GENRE@}';
    this.urlSearchTalent = '/search?id={@ID_TALENT@}&type=talent&q={@TALENT@}';
    this.urlSearchWord = '/search?q={@WORDS@}';
    this.urlState = typeof window.history.pushState === 'undefined' ? false : true;

    this.initialize = function() {
        var elSearch = mthis.getSearchWords();
        mthis.predictivo = false;
        this.buscador = elSearch.autocompletepredictive({
            bootstrap: typeof elSearch.attr('bootstrap') !== 'undefined' ? true : false,//false,
            serviceUrl: mthis.urlPredict,
            minChars: 1,
            deferRequestBy: 0,
            params: { layoutOff : 'true' },
            noCache: true,
            onSelect: function(params) {
              mthis.setBuscadorValue(params.text);
              mthis.buscar(params);
            },
            parent: mthis,
            isBootStrap: true
        });

        this.initText = elSearch.val();

        if (this.initText === '' && elSearch.attr('leading') !== '' && elSearch.attr('leading') !== 'seekLeading' && elSearch.val() === '') {
            elSearch.addClass('leading').val(elSearch.attr('leading'));
        } else {
            elSearch.val(this.initText);
        }

        elSearch.bind('focus click keypress', function() {
            if (elSearch.attr('class') === 'leading') {
                elSearch.removeClass('leading').val('');
            }
        });

        if (this.urlState === true) {
            $(window).bind('popstate', function(e) {
                mthis.triggerUrl(mthis.getUrlParams());
            });            
        }
    };

    this.triggerUrl = function(params) {
        this.getSearchWords().attr('fakeSearch', '1');

        if (typeof params.searchMovie !== 'undefined') {
            this.getSearchWords().val(decodeURIComponent(params.words));
            this.getSearchWords().prop('value', decodeURIComponent(params.words));
                
            var ev = jQuery.Event('keyup');
            ev.which = 13;
            ev.keyCode = 13;
            this.getSearchWords().trigger(ev);
            $('#searchIcon').trigger('click');
        } else if (typeof params.searchTalent !== 'undefined') {
            this.getSearchWords().val(decodeURIComponent(params.talent));
            this.getSearchWords().prop('value', decodeURIComponent(params.talent));
            this.buscar(params);
        } else {}

        this.getSearchWords().attr('fakeSearch', '0');
    },
    this.modifyUrl = function(params){
        if(this.urlState === true){
            var url;
            
            if(typeof params.id === 'undefined'){ // Es una cadena de texto -> va a search generico
                url = window.fwk.commonGetMyBaseSeoUrlOnlyRegion(this.urlSearchWord.replace('{@WORDS@}', encodeURIComponent(params.text)));
                window.history.pushState({}, null, url);
            }else{
                switch(params.type){
                    case 'T': // Es un talent -> verticalSearch
                        url = this.urlSearchTalent.replace('{@ID_TALENT@}', params.id).replace('{@TALENT@}', encodeURIComponent(params.text));
                        url = window.fwk.commonGetMyBaseSeoUrlOnlyRegion(url);
                        window.history.pushState({}, null, url);
                        break;
                }
            }
        }
    },
    this.getUrlParams = function(){
        var params = {};

        if (location.search) {
            var parts = location.search.substring(1).split('&');

            for (var i = 0; i < parts.length; i++) {
                var nv = parts[i].split('=');
                if (!nv[0]) continue;
                params[nv[0]] = nv[1] || true;
            }
        }
        return params;
    },
    this.buscar = function(params){
        if (typeof params.id === 'undefined') {
            var url = '/' + utils.userType.checkRegion() + this.urlSearchWord.replace('{@WORDS@}', encodeURIComponent(params.text));
            document.location.assign(url);
        } else {
            document.location.assign(params.url);
        }
    };

    this.getSearchWords = function() {
        if($('#buscadorWords-full:visible').length !== 0){
            return $('#buscadorWords-full');
        }else if($('#buscadorWords-mobile:visible').length !== 0){
            return $('#buscadorWords-mobile');
        }else{
            return $('#buscadorWords');
        }
    };

    this.setBuscadorValue = function(text){
        this.getSearchWords().val(text);
    };

    this.keyChange = function(word) {
        var leading = mthis.getSearchWords().attr('leading');
        
        if((leading !== '' && leading === word) || $.trim(word) === ''){
            return false;
        }
    };

    this.wordsChange = function(obj, id, text, data) {
        var leading    = mthis.getSearchWords().attr('leading'),
            parametros = this.getParameters($('#ordlist_page').attr('parametros'));

        if ((leading !== '' && leading === text) || $.trim(text) === '') {
            return(false); //si es el leading no hago nada y si no hay valor tampoco
        }

        if (typeof id === 'undefined' || id === '') {
            return;
        }

        if (id.substr(0, 1) === 'G') { //es una busqueda comun
            parametros.words     = escape(text);
            parametros.value     = '';
            parametros.field     = '';
            parametros.valuetext = text;
        } else {}
    };
};
